import { CustomerInfoDto, PersonInfoDto } from './MooringOffers';
import { MooringSiteSetupDto } from './MooringSiteSetup';

export const MooringProductionOrderStatus = {
  New: 1,
  InProduction: 2,
  ReadyForPickup: 3,
  PickedUp: 4,
  Completed: 5,
  Canceled: 6,
} as const;

export type MooringProductionOrderStatus = (typeof MooringProductionOrderStatus)[keyof typeof MooringProductionOrderStatus];

export const MooringProductionStatusTranslation: { [key in MooringProductionOrderStatus]: string } = {
  '1': 'mooring.status.new',
  '2': 'mooring.status.inProduction',
  '3': 'mooring.status.readyForPickup',
  '4': 'mooring.status.pickedUp',
  '5': 'mooring.status.completed',
  '6': 'mooring.status.canceled',
};

export class MooringProductionOrderListItemDto {
  Id: number;
  Created: string;

  Customer?: string;
  CustomerId?: number;

  Title: string;
  OfferTitle: string;

  Contact?: string;
  ContactId?: number;

  Locality?: string;
  LocalityId?: number;
  LocalityNumber?: string;

  Status: MooringProductionOrderStatus;
}

export class MooringProductionOrderDto {
  Id: number;
  MooringId: number;
  Status: MooringProductionOrderStatus;

  Created: Date;
  Updated: Date;

  Customer?: CustomerInfoDto;

  ResponsibleId?: string;
  ResponsibleName?: string;

  Contact?: PersonInfoDto;

  Locality: string;
  LocalityNumber: string;

  SiteSetup: MooringSiteSetupDto;

  EstimatedProductionTime: number;

  EstimatedWeightCages: number;
  EstimatedWeightGridLines: number;
  EstimatedWeightAnchorLines: number;
  EstimatedWeightBuoys: number;
  EstimatedWeightBridles: number;
  EstimatedWeightFleetAnchorLines: number;
}

export class CreateMooringProductionOrderDto {
  offerId: number;
}

export class UpdateMooringProductionOrderDto {
  ResponsibleId: string;

  EstimatedProductionTime: number = 0;

  EstimatedWeightGridLines: number = 0;
  EstimatedWeightAnchorLines: number = 0;
  EstimatedWeightBuoys: number = 0;
  EstimatedWeightBridles: number = 0;
  EstimatedWeightFleetAnchorLines: number = 0;
}

export class MooringProductionOrderStatusPipelineItem {
  StatusId: number;
  MooringProductionStatusOption: any;
  MooringProductionOrders: MooringProductionOrderDto[];
}

export class UpdateMooringProductionOrderStatusContentQueueDto {
  MooringProductionOrders: UpdateMooringProductionOrderStatusContentQueueItem[];
}

export class UpdateMooringProductionOrderStatusContentQueueItem {
  MooringProductionOrderId: number;
  SortIndex: number;
}
